(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@babylonjs/core"));
	else if(typeof define === 'function' && define.amd)
		define("@babylonjs/node-editor", ["@babylonjs/core"], factory);
	else if(typeof exports === 'object')
		exports["@babylonjs/node-editor"] = factory(require("@babylonjs/core"));
	else
		root["NODEEDITOR"] = factory(root["BABYLON"]);
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), (__WEBPACK_EXTERNAL_MODULE__2395__) => {
return 